<template>
  <div>
    <b-card
      no-body
    >
      <b-link
        :to="{ name: 'applied-doc-count-by-org' }"
        class="m-1"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="16"
        />
        <span class="ml-50 font-weight-bold">{{ organization ? $langName(organization.name) : '' }}</span>
      </b-link>
      <div class="mx-2 mb-2">
        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="8"
          >
            <h3 class="text-center mb-1">
              {{ $t("Received applied applications by directions") }}
            </h3>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('Search...')"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="applyDocCountByOrganizationTable"
        :items="appliedDocCountByDirection"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        :busy="isBusy"
        :filter="searchQuery"
        class="position-relative"
      >
        <template #head(name)="data">
          {{ $t(data.label) }}
        </template>

        <!-- Column: Id -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template
          v-for="id in dc_types"
          #[`cell(${id})`]="data"
        >
          {{ data.item[`quote_${id}`] }} / {{ data.item[`apply_${id}`] }}
        </template>

        <template #cell(name)="data">
          {{ data.item.code }} - {{ $langName(data.value) }}

        </template>

      </b-table>
    </b-card>
  </div>

</template>

<script>
import {
  BCard, BTable, BRow, BCol, BFormInput, BLink,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import statisticModule from '@/store/statistic'
import periodModule from '@/store/period'
import orgModule from '@/store/organization'

export default {
  name: 'AppliedDocCountByOrganization',
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormInput,
    BLink,
  },
  data() {
    return {
      periodId: null,
      orgId: null,
      organization: null,
    }
  },
  computed: {
    appliedDocCountByDirection() {
      return this.$store.state[this.MODULE_NAME].appliedDocCountByDirection
    },
    periods() {
      return this.$store.state[this.MODULE_PERIOD].periods
    },
    applyDocumentStatuses() {
      return this.$store.state.staticModule.applyDocumentStatuses
    },
  },
  created() {
    this.orgId = this.$route.params.orgId
    this.periodId = this.$route.params.periodId
    this.refetchData()
    this.$store.dispatch(`${this.MODULE_ORG}/get`, this.orgId).then(({ data }) => {
      this.organization = data
    })
  },
  methods: {
    refetchData() {
      if (this.orgId && this.periodId) {
        this.isBusy = true
        this.$store.dispatch(
          `${this.MODULE_NAME}/appliedDocCountByDirection`,
          { period_id: this.periodId, org_id: this.orgId },
        ).then(() => {
          this.isBusy = false
        })
      }
    },
    loadPeriods() {
      this.$store.dispatch(`${this.MODULE_PERIOD}/list`)
    },
    search() {
      this.refetchData()
    },
    getApplyDocumentStatus(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatus'](id)
    },
    getApplyDocumentDcTypes(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
  },
  setup() {
    const MODULE_NAME = 'statisticFront'
    const MODULE_PERIOD = 'periodFront'
    const MODULE_ORG = 'organization'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, statisticModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)
    if (!store.hasModule(MODULE_ORG)) store.registerModule(MODULE_ORG, orgModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_PERIOD)
      if (store.hasModule(MODULE_ORG)) store.unregisterModule(MODULE_ORG)
    })

    const {
      DSc,
      PhD,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
      dcTypes,
    } = store.state.staticModule

    // eslint-disable-next-line camelcase
    const dc_types = [
      DSc,
      PhD,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      targetedPhD,
      targetedDSc,
    ]
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'name' },
    ]
    dcTypes.forEach(x => {
      if (dc_types.includes(x.id)) {
        tableColumns.push({ key: `${x.id}`, label: `${x.name.uz}` })
      }
    })
    const isBusy = false
    const searchQuery = ''

    return {
      tableColumns,
      isBusy,
      searchQuery,
      MODULE_NAME,
      MODULE_PERIOD,
      dc_types,
      MODULE_ORG,
    }
  },
}
</script>

<style scoped>

</style>
